<template>
  <div id="call-detail-card">
    <div class="title-label">コール詳細</div>
    <div class="content-area">
      <p class="caption-label">{{ convertTitle(callDetailData.callType) }}</p>
      <table>
        <tr>
          <th>コールID</th>
          <td>{{ callDetailData.callId }}</td>
        </tr>
        <tr>
          <th>患者コード</th>
          <td>{{ convertDisplay(callDetailData.patientCode) }}</td>
        </tr>
        <tr>
          <th>患者名</th>
          <td>{{ callDetailData.patientName }}</td>
        </tr>
        <tr>
          <th>郵便番号</th>
          <td>{{ callDetailData.patientPostcode }}</td>
        </tr>
        <tr>
          <th>住所</th>
          <td>{{ callDetailData.patientAddress }}</td>
        </tr>
        <tr>
          <th>住所（丁目、番地）</th>
          <td>{{ callDetailData.patientAddressHouseNumber }}</td>
        </tr>
        <tr>
          <th>住所（建物名、号室）</th>
          <td>{{ callDetailData.patientAddressBuildingName }}</td>
        </tr>
        <tr>
          <th>担当支店</th>
          <td>{{ callDetailData.chargeBranchName }}</td>
        </tr>
        <tr>
          <th>担当営業者名</th>
          <td>{{ callDetailData.salesStaffName }}</td>
        </tr>
        <tr>
          <th>医療機関名</th>
          <td>{{ callDetailData.medicalInstitutionName }}</td>
        </tr>
        <tr>
          <th>病院コード</th>
          <td>{{ callDetailData.medicalInstitutionCode }}</td>
        </tr>
        <tr>
          <th>該当機器名</th>
          <td>{{ convertDeviceModelName() }}</td>
        </tr>
        <tr>
          <th>該当機器シリアル</th>
          <td>{{ callDetailData.deviceSerial }}</td>
        </tr>
        <tr>
          <th>請求先コード</th>
          <td>{{ convertDisplay(callDetailData.cpapBillingTargetCode) }}</td>
        </tr>
        <tr>
          <th>請求先名</th>
          <td>{{ convertDisplay(callDetailData.cpapBillingTargetName) }}</td>
        </tr>
        <tr>
          <th><br /></th>
          <td></td>
        </tr>
        <tr>
          <th>連絡先（携帯電話）</th>
          <td>{{ convertDisplay(callDetailData.patientMobilePhone) }}</td>
        </tr>
        <tr>
          <th>連絡（自宅・その他）</th>
          <td>{{ callDetailData.patientPhoneNumber }}</td>
        </tr>
        <tr>
          <th>患者名（カナ）</th>
          <td>{{ callDetailData.patientNameKana }}</td>
        </tr>
        <tr>
          <th><br /></th>
          <td></td>
        </tr>
        <tr>
          <th>コール実施者名</th>
          <td>{{ callDetailData.callStaffName }}</td>
        </tr>
        <tr>
          <th>対応日</th>
          <td>{{ formatDate(callDetailData.callImplementationDate) }}</td>
        </tr>
        <tr>
          <th>対応開始時刻</th>
          <td>{{ formatTime(callDetailData.callStartTime) }}</td>
        </tr>
        <tr>
          <th>対応終了時刻</th>
          <td>{{ formatTime(callDetailData.callEndTime) }}</td>
        </tr>
        <tr>
          <th>対応所要時間</th>
          <td>{{ calculateCallTurnaroundTimes() }} 分</td>
        </tr>
        <tr>
          <th>コール結果</th>
          <td>
            {{ convertCallStatus(callDetailData.callStatus) }}
          </td>
        </tr>
        <tr>
          <th>最終ヒアリング内容1</th>
          <td class="content-text">{{ callDetailData.hearing1 }}</td>
        </tr>
        <tr>
          <th>最終ヒアリング内容2</th>
          <td class="content-text">{{ callDetailData.hearing2 }}</td>
        </tr>
        <tr>
          <th>最終ヒアリング内容3</th>
          <td class="content-text">{{ callDetailData.hearing3 }}</td>
        </tr>
        <tr>
          <th>最終ヒアリング内容4</th>
          <td class="content-text">{{ callDetailData.hearing4 }}</td>
        </tr>
        <tr v-if="callDetailData.callType == beforeShippingCode">
          <th>コール実施</th>
          <td>
            <span v-if="callDetailData.afterCall">到着後コールを行う</span>
            <span v-else>到着後コールを行わない</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  cpapCallTypeList,
  cpapCallStatusList,
} from "@/components/mock/base/const.js";

export default {
  data() {
    return {
      callTypeList: cpapCallTypeList,
      callStatusList: cpapCallStatusList,
      cpapDeviceList: this.getCpapMaster(),
      inspectionDeviceList: [],
      beforeShippingCode: 1
    };
  },
  props: {
    callDetailData: {},
  },
  methods: {
    convertTitle(val) {
      let text = "";
      let finding = this.callTypeList.find((item) => item.code == val);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertCallStatus(status) {
      let text = "";
      let finding = this.callStatusList.find((item) => item.code == status);
      if (finding) {
        text = finding.name;
      }
      return text;
    },
    convertDeviceModelName() {
      let deviceName = "";
      let device = null;
      switch (this.callDetailData.deviceTypeCode) {
        case "CPAP":
          device = this.cpapDeviceList.find(item => item.itemCodes.indexOf(this.callDetailData.deviceItemCode) != -1);
          deviceName = device ? device.itemName : "";
          break;
        case "HST":
        case "CORP":
        case "HOLTER":
          device = this.inspectionDeviceList.find(item => item.value == this.callDetailData.inspectionDeviceId);
          deviceName = device ? device.kind : "";
          break;
        default:
          break;
      }
      return deviceName;
    },
    convertDisplay(val) {
      let text = "";
      if(this.callDetailData.deviceTypeCode == "CPAP") {
        text = val;
      } else {
        text = "ー";
      }
      return text;
    },
    formatDate(date) {
      return date ? date.replace(/-/g, "/") : "";
    },
    formatTime(time) {
      let formattedTime = "";
      if(time) {
        let splittedTime = time.split(":");
        formattedTime =  `${splittedTime[0]}時${splittedTime[1]}分`
      }
      return formattedTime;
    },

    calculateCallTurnaroundTimes() {
      let callTurnaroundTimes = "ー";
      if(this.callDetailData.callStartTime && this.callDetailData.callEndTime) {
        let now = new Date();
        let startHour = this.callDetailData.callStartTime.split(":")[0];
        let startMinutes = this.callDetailData.callStartTime.split(":")[1];
        let endHour = this.callDetailData.callEndTime.split(":")[0];
        let endMinutes = this.callDetailData.callEndTime.split(":")[1];
        let fromTime = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate(), startHour, startMinutes);
        let toTime = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate(), endHour, endMinutes);
        callTurnaroundTimes = (toTime - fromTime)  / (60 * 1000);
      }
      return callTurnaroundTimes;
    },

    findInspectionDevices() {
      let requestApi = this.findInspectionDevicesApi;
      let successCallBack = this.findInspectionDevicesSuccess;
      let errorCallBack = this.findInspectionDevicesError;
      this.apiCall(requestApi, successCallBack, errorCallBack);
    },
    findInspectionDevicesApi(client) {
      return client.apis.internalDeviceManagement.getDeviceKindsPOST({
        body: {}
      });
    },
    findInspectionDevicesSuccess(result) {
      this.inspectionDeviceList = result.obj;
    },
    findInspectionDevicesError(error) {
      // this.showErrorMessage(error);
    },
  },
  created() {
    this.findInspectionDevices();
  }
};
</script>

<style scoped>
#call-detail-card {
  margin: 0.5em;
}
.title-label {
  background-color: #000894;
  color: whitesmoke;
  text-align: left;
  padding: 0 10px;
}
.caption-label {
  font-size: 20px;
  margin: 0.5em 0;
}
.content-area {
  margin-top: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
}
table tr th {
  width: 30%;
  font-size: 15px;
  padding: 0.2em 0;
}
table tr td {
  font-size: 15px;
  padding: 0.2em;
}
table tr td > * {
  width: 100%;
}
.content-text {
  word-break: break-all;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/escalation/components/CallDetailCard.vue